//import liraries
import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import applicationStyles from '../styles/applicationStyles';
import { CreateResponsiveStyle,  DEVICE_SIZES} from "rn-responsive-styles";
import { COLORS, FONTS } from "../constant";

// create a component
const CustomButton = (props) => {
    const customStyle = props.customStyle
    const skipButton = props.skipButton || false
    const styles = useStyles();
    return (
        <>

            {skipButton ?
                <TouchableOpacity
                    onPress={props.onPress}
                    style={[styles.skipButton,{borderColor: props.borderColor ? props.borderColor : COLORS.red,width: props.width ? props.width : 176,height: props.height ? props.height : 41}]}>
                    <Text style={[styles.skipText,{color : props.color ? props.color : COLORS.red,padding : props.padding ? props.padding : 11}]}>
                        {props.text}
                    </Text>
                </TouchableOpacity>
                :
                <TouchableOpacity
                    onPress={props.onPress}
                    style={props.style ? props.style : props.disable ? applicationStyles.buttonContainerStyleDisable : [applicationStyles.buttonContainerStyle, { backgroundColor: props.backgroundColor }]}>
                    <Text style={props.textStyle ? props.textStyle : [applicationStyles.buttonTextStyle, { fontSize: props.fontSize,color:props.color }]}>
                        {props.text}
                    </Text>
                </TouchableOpacity>}
        </>
    );
};

// define your styles
const useStyles = CreateResponsiveStyle(

    {
        buttonStyle1: {
            alignItems: "center",
            justifyContent: "center",
            marginTop: 10,
            alignSelf: "center",
            width: 108.3,
            height: 40.7,
            borderRadius: 12,
             shadowColor: "rgba(0, 0, 0, 0.08)",
            shadowOffset: {
                width: 0,
                height: 10
            },
            shadowRadius: 5,
            shadowOpacity: 1
        },
        skipButton: {
            width: 176,
            height: 41,
            borderRadius: 20.5,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: COLORS.red
        },
        skipText: {
            padding: 11,
            fontFamily: FONTS.InterBold,
            fontSize: 14,
            fontWeight: "bold",
            fontStyle: "normal",
            letterSpacing: 0,
            textAlign: "center",
            color: COLORS.red
        },

    
        buttonStyle: {
            width: 128,
            height: 29,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "#9c1d25",
            borderRadius: 15,
        },
        textStyle: {
            marginTop: 5,
            fontFamily: FONTS.InterBold,
            fontSize: 12,
            fontWeight: "500",
            fontStyle: "normal",
            textAlign: "center",
            color: "#9c1d25"
        }
    },
    {
        [DEVICE_SIZES.LG]: {},
        [DEVICE_SIZES.MD]: {},
        [DEVICE_SIZES.SM]: {
            skipButton: {
                width: 86,
                height: 24,
                alignItems:"center"
            },
            skipText: {
                fontSize: 10,
                padding:5
            },
            buttonStyle1:{
                width: 86,
                height: 24,
            }
        },
        [DEVICE_SIZES.XS]: {
            skipButton: {
                width: 86,
                height: 24,
                alignItems:"center",
                marginBottom:5
            },
            skipText: {
                fontSize: 10,
                padding:5,
                fontWeight:'bold'
            },
            buttonStyle1:{
                width: 86,
                height: 24,
            }
        },
    }
);

//make this component available to the app
export default CustomButton;
